import { apiRequest } from '@common/api/utils';

function getUserTraits() {
  return apiRequest(
    'GET',
    '/analytics/',
  );
}

export default {
  getUserTraits,
};
